if (!customElements.get('sg-product-tabs')) {
  customElements.define('sg-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const tabs = [...this.querySelectorAll('[data-info-tab]')];
      const panels = [...this.querySelectorAll('[data-info-panel]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      const nav = this.querySelector('.sd-info-tabs__nav');
      let current = 0;
      const select = (index, focus = false) => {
        current = index;
        tabs.forEach((tab, i) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].tabIndex = 0;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i), {signal: this.controller.signal});
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        }, {signal: this.controller.signal});
      });
      // Da 900px in su i pannelli stanno affiancati: le schede non servono e restano entrambi visibili.
      const split = matchMedia('(min-width: 900px)');
      const row = document.querySelector('[data-info-row]');
      if (row && !this.anchor) { this.anchor = document.createComment('sg-product-tabs'); this.before(this.anchor); }
      const apply = () => {
        if (row) {
          // Affiancate stanno sotto la galleria, a tutta larghezza; a schede tornano nella colonna d'acquisto.
          if (split.matches && this.parentElement !== row) row.append(this);
          if (!split.matches && this.anchor.parentNode && this.parentElement !== this.anchor.parentNode) this.anchor.parentNode.insertBefore(this, this.anchor);
          row.hidden = !split.matches;
        }
        if (split.matches) {
          this.classList.remove('is-ready');
          nav.removeAttribute('role');
          tabs.forEach(tab => { tab.removeAttribute('role'); tab.removeAttribute('aria-selected'); tab.tabIndex = -1; });
          panels.forEach(panel => { panel.removeAttribute('role'); panel.removeAttribute('tabindex'); panel.hidden = false; });
        } else {
          this.classList.add('is-ready');
          nav.setAttribute('role', 'tablist');
          select(current);
        }
      };
      split.addEventListener('change', apply, {signal: this.controller.signal});
      apply();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
